import { api } from './client';
import type { Publication, CreatePublicationData } from '../../entities/publication';

export interface PaginationInfo {
  page: number;
  limit: number;
  totalCount: number;
  totalPages: number;
}

export interface PaginatedPublications {
  publications: Publication[];
  pagination: PaginationInfo;
}

export const publicationsApi = {
  async getAll(): Promise<Publication[]> {
    // v3.0: chunked fetch на сервере чтобы обойти PostgREST 1000 limit
    const response = await api.get<{ publications: Publication[] }>(`/publications?v=3.0&_t=${Date.now()}`);
    return response.publications;
  },

  async getPaginated(page: number = 1, limit: number = 50): Promise<PaginatedPublications> {
    const response = await api.get<PaginatedPublications>(
      `/publications?page=${page}&limit=${limit}&_t=${Date.now()}`
    );
    return response;
  },

  async getByBatchOrId(batchOrId: string): Promise<{ publications: Publication[]; isBatch: boolean }> {
    return api.get<{ publications: Publication[]; isBatch: boolean }>(
      `/publications/batch/${batchOrId}`
    );
  },

  async getByAccount(accountId: string): Promise<Publication[]> {
    const response = await api.get<{ publications: Publication[] }>(
      `/publications/account/${accountId}`
    );
    return response.publications;
  },

  async create(data: CreatePublicationData): Promise<Publication> {
    const response = await api.post<{ publication: Publication }>('/publications', data);
    return response.publication;
  },

  async getInsights(publicationId: string): Promise<Publication> {
    const response = await api.get<{ publication: Publication }>(
      `/publications/${publicationId}/insights`
    );
    return response.publication;
  },

  async refreshInsights(idOrBatchId: string): Promise<Publication[]> {
    // Используем новый endpoint для поиска по batchId/id без загрузки всех публикаций
    const result = await this.getByBatchOrId(idOrBatchId);
    
    // Обновляем insights для каждой публикации
    const updatedPublications = await Promise.all(
      result.publications.map(pub => this.getInsights(pub.id))
    );

    return updatedPublications;
  },

  async delete(publicationId: string): Promise<void> {
    await api.delete(`/publications/${publicationId}`);
  },
};